import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { doGetMidtransPaymentDetail, doGetMidtransSavedToken } from '../../../../../actions/paymentAction';
import Footer from './Footer';
import Loading from './Loading';
import {withRouter} from "react-router-dom"

class Midtrans extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      _trxId: null,
      _trxTkn: props.trxTkn,
      _paymentType: 'bank_transfer',
      _vaNumber: null,
      _vaType: null,
      _isLoading: true
    }
  }
  componentDidMount(){
    this.props.getMidtransDetail(this.props.data.invoice_number);
  }

  componentDidUpdate(prevProps) {
    if(prevProps.dataMidtrans.isFetch && !this.props.dataMidtrans.isFetch){
      const { error, data } = this.props.dataMidtrans;
      if(!error){
        this.setState({
          _trxId: data.transaction_id,
          _trxTkn: data.transaction_token,
          _paymentType: data.payment_type,
          _vaNumber: data.va_number? data.va_number.split('').map((c, index) => {
            if((data.status !== 'pending' || data.is_expired) && index > 2) return 'X';
            return c;
          }).join(''): null,
          _vaType: data.va_type,
          _isLoading: false
        })
      }
    }
  }
  render(){
    return(
      <>
        {
          this.state._trxTkn === null && this.state._isLoading?
            <Loading/>
          :
          <Footer
            userCurrency={this.props.userCurrency}
            isLoading={this.state._isLoading}
            trxId={this.state._trxId}
            trxTkn={this.state._trxTkn}
            vaType={this.state._vaType}
            vaNumber={this.state._vaNumber}
            expire={this.props.expire}
            onClick={this.props.onClick}
            dataPayment={this.props.data}
            onSaveTokens={this.props.savedCreditCardTokens}
            history={this.props.history}
            product={this.props.product}
            orderDetailsData={this.props.orderDetailsData}
          />
        }
      </>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  getMidtransDetail: invoice => dispatch(doGetMidtransPaymentDetail(invoice)),
  savedCreditCardTokens: payload => dispatch(doGetMidtransSavedToken(payload))
})

const mapStateToProps = ({ dataPayment: { midtrans: { details } } }) => ({
  dataMidtrans: details
})
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Midtrans));
